import { apiClient } from './api'

export interface PortfolioGovernanceMetrics {
  portfolio_count: number
  project_count: number
  stage_gate_count: number
  pending_gates: number
  completed_gates: number
  rejected_gates: number
  overdue_gates: number
  /** Percentage of governed projects whose gates are all approved, or null
   *  when no project has any gates yet. */
  compliance_rate: number | null
  governed_projects: number
}

export interface PortfolioGovernanceStageGate {
  id: number
  project_id: number
  project_name: string
  portfolio_name: string | null
  gate_number: string
  name: string
  status: string
  progress: number
  due_date: string | null
  completed_date: string | null
  approver: string | null
  risk_status: string | null
  documents: { total: number; completed: number }
  decisions: { total: number; approved: number }
}

export interface PortfolioGovernanceAuditEntry {
  id: number
  action: string
  entity_type: string
  entity_id: number | null
  description: string | null
  user_id: number | null
  created_at: string | null
}

export interface PortfolioGovernanceOverview {
  metrics: PortfolioGovernanceMetrics
  stage_gates: PortfolioGovernanceStageGate[]
  audit_log: PortfolioGovernanceAuditEntry[]
}

export const portfolioGovernanceService = {
  async overview(portfolioId?: number, auditLimit = 20): Promise<PortfolioGovernanceOverview> {
    const params: Record<string, number> = { audit_limit: auditLimit }
    if (portfolioId !== undefined) params.portfolio_id = portfolioId
    const { data } = await apiClient.get<PortfolioGovernanceOverview>(
      '/api/v1/portfolio-governance/overview',
      { params },
    )
    return data
  },
}
